<template>
    <div>
        <b-form-group label-for="phyAct">
            <template slot="label"
                >{{ $t("pages.forms.nutrition.phyact.title")
                }}<span v-if="required" :class="requiredClasses"
                    >*</span
                ></template
            >
            <validation-provider
                :rules="{ required }"
                v-slot="{ errors, dirty, valid, validated, classes }"
            >
                <multiselect
                    id="phyAct"
                    v-model="phyAct"
                    :options="phyActOptions"
                    :multiple="false"
                    :allowEmpty="false"
                    :placeholder="
                        $t('pages.forms.select-descriptors.placeholder')
                    "
                    :deselectLabel="
                        $t('pages.forms.select-descriptors.deselectlabel')
                    "
                    :selectedLabel="
                        $t('pages.forms.select-descriptors.selectedlabel')
                    "
                    :selectLabel="
                        $t('pages.forms.select-descriptors.selectlabel')
                    "
                    label="text"
                    track-by="value"
                    openDirection="above"
                    :class="classes"
                    :maxHeight="350"
                    @input="update"
                    v-show="!isReviewing"
                    data-cypress-id="phy-act"
                />
                <div
                    v-if="(dirty || validated) && !valid"
                    class="invalid-feedback"
                >
                    {{ errors[0] }}
                </div>
            </validation-provider>
            <b-form-input
                type="text"
                readonly
                plaintext
                v-show="isReviewing"
                :value="phyActValue"
            />
        </b-form-group>
        <b-form-group>
            <b-button
                v-show="!isReviewing"
                variant="secondary"
                v-b-modal.phyActModal
                :centered="true"
                >{{
                    $t("pages.forms.nutrition.phyact.modal.buttonText")
                }}</b-button
            >
            <b-modal
                id="phyActModal"
                :title="$t('pages.forms.nutrition.phyact.modal.title')"
                title-tag="h5"
                :hide-footer="true"
            >
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op1")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op1") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op2")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op2") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op3")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op3") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op4")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op4") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op5")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op5") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op6")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op6") }}
                </p>
                <p>
                    <span style="font-weight: bold">{{
                        $t("pages.forms.nutrition.phyact.modal.keyword.op7")
                    }}</span
                    >: {{ $t("pages.forms.nutrition.phyact.modal.desc.op7") }}
                </p>
            </b-modal>
        </b-form-group>
    </div>
</template>

<script>
import FormInputHelpers from "../../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            phyAct: this.value
        };
    },
    props: {
        value: null,
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update(value) {
            this.$emit("input", value);
        }
    },
    computed: {
        phyActOptions() {
            return [
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op1"
                    ),
                    value: 1
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op2"
                    ),
                    value: 2
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op3"
                    ),
                    value: 3
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op4"
                    ),
                    value: 4
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op5"
                    ),
                    value: 5
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op6"
                    ),
                    value: 6
                },
                {
                    text: this.$i18n.t(
                        "pages.forms.nutrition.phyact.options.op7"
                    ),
                    value: 7
                }
            ];
        },
        isReviewing() {
            return this.reviewing;
        },
        phyActValue() {
            if (this.value != null) {
                return this.value.text;
            }
            return this.value;
        }
    }
};
</script>
